<template>
    <div>
        <commonTopbar></commonTopbar>
        <commonHeader></commonHeader>
        <div class="container">
            <router-view />
        </div>
        <commonFooter></commonFooter>
    </div>
</template>

<script>
    import commonTopbar from '@/components/common/topbar.vue'
    import commonHeader from '@/components/common/header.vue'
    import commonFooter from '@/components/common/footer.vue'
    export default {
        name: 'App',
        components: {
            commonTopbar,
            commonHeader,
            commonFooter
        },
        data() {
            return {
                msg: 'Welcome to Your Vue.js App'
            }
        }
    }
</script>

<style lang="scss">
    body , html{
        background: #FFF6E7;
    }
    .container {
        width: 1100px;
        margin: 0 auto;
    }    
    .flex {
        display: flex;
    }

    .button-1 {
        background: linear-gradient(#B4761F, #794F1F);
        border-radius: 3px;
        color: #ffffff;
        text-align: center;
        line-height: 30px;
        border: 0 none;
        cursor: pointer;
        font-family: 'Microsoft Yahei', sans-serif;
        font-size: 14px;
        appearance: none;
        &:hover {
            background: linear-gradient(#B4761F, #B4761F);
        }
        &:focus {
            outline: none;
        }
    }
    .button-2 {
        background: linear-gradient(#FFFEFA, #FDD7AA);
        border-radius: 3px;
        color: #88522a;
        text-align: center;
        line-height: 30px;
        border: 0 none;
        cursor: pointer;
        font-family: 'Microsoft Yahei', sans-serif;
        font-size: 14px;
        appearance: none;
        &:hover {
            background: linear-gradient(#FDD7AA, #FDD7AA);
        }
        &:focus {
            outline: none;
        }
    }

    .pagination {
        display: flex;
        justify-content: space-between;
        padding: 0 40px;
        box-sizing: border-box;
        font-size: 14px;
        .l {
            color: #916f45;
            span {
                line-height: 30px;
                b {
                    font-weight: bold;
                }
            }
        }
        .r {
            button {
                width: 60px;
                + button {
                    margin-left: 5px;
                }
            }
        }
    }
    .scrollbar {
        overflow-y: auto;
        /*滚动条整体样式*/
        &::-webkit-scrollbar {
            width: 6px;
            background-color: #E3CBA7;
        }
        /*滚动条里面轨道*/
        &::-webkit-scrollbar-track {
            background-color: #E3CBA7;
        }
        /*滚动条里面小方块*/
        &::-webkit-scrollbar-thumb {
            background: #CCA770;
            border-radius: 10px;
        }
        &::-webkit-scrollbar-button:start {
            height: 0;
        }
        &::-webkit-scrollbar-button:end {
            height: 0;
        }
    }
    
    .page-main {
        margin-top: 15px;
        border: 1px solid #EFDECC;
        box-shadow:0 6px 20px #EFDECC;
        border-radius: 10px;
        background: #FFF9F3;
        
        .main-bd {
            padding: 15px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            .main-bd_left {
                width: 530px;
                height: 590px;
                background: #FFF5E9;
                border: 1px solid #DDA76B;
                box-sizing: border-box;
                .hd {
                    height: 44px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    box-sizing: border-box;
                    padding: 0 16px 0 10px;
                    background: linear-gradient(#B9791F, #794F1F);
                    .tit {
                        font-size: 16px;
                        color: #ffffff;
                        position: relative;
                        padding-left: 12px;
                        cursor: pointer;
                        &::before {
                            position: absolute;
                            background: #FEF1A2;
                            border-radius: 3px;
                            width: 6px;
                            height: 20px;
                            left: 0;
                            top: 1px;
                            content: ' ';
                        }
                    }
                    .operation {
                        font-size: 14px;
                        color: #fdd2a0;
                        span {
                            padding: 0 8px;
                            line-height: 30px;
                            display: inline-block;
                            cursor: pointer;
                            border-radius: 5px;
                            &.active,&:hover {
                                background: linear-gradient(#FFFCF5, #FED5A7);
                                color: #794F1F;
                                .icon-ph {
                                    background-image: url('../../assets/images/ph_select.png');
                                }
                                .icon-sc {
                                    background-image: url('../../assets/images/sc_02.png');
                                }
                            }
                        }
                        i {                        
                            background-position: center center;
                            background-repeat: no-repeat;
                            background-size: 15px 15px;
                            margin-right: 2px;
                            display: inline-block;
                            width: 15px;
                            height: 15px;
                            vertical-align: middle;
                        }
                        .icon-ph {
                            background-image: url('../../assets/images/ph.png');
                        }
                        .icon-sc {
                            background-image: url('../../assets/images/sc_01.png');
                        }
                    }
                }
                .bd {
                    .list {
                        padding-top: 10px;
                        padding-left: 6px;
                        height: 503px;
                        box-sizing: border-box;
                        .item {
                            width: 95px;
                            line-height: 30px;
                            text-align: center;
                            border: 1px solid #E5C7A1;
                            background: #FAEADA;
                            color: #88522a;
                            margin-left: 5px;
                            margin-bottom: 6px;
                            cursor: pointer;
                            border-radius: 5px;
                            display: inline-block;
                            &.active {
                                color: #ffffff;
                                background: #9A681F;
                                border-color: #9A681F;
                            }
                        }
                    }
                    .pagination {
                        margin-top: 5px;
                    }
                    .line-list {
                        .col-1 {
                            width: 55px;
                        }
                        .col-2 {
                            width: 155px;
                        }
                        .col-3 {
                            width: 110px;
                        }
                        .col-4 {
                            width: 90px;
                        }
                        .col-5 {
                            width: 90px;
                        }
                        .col-last {
                            width: 10px;
                        }
                        .line-list_hd {
                            background: #AF7A38;
                            height: 30px;
                            line-height: 30px;
                            color: #ffffff;
                            text-align: center;
                            display: flex;
                            justify-content: space-between;
                        }
                        .line-list_bd {
                            background: #FFF6E7;
                            height: 514px;
                            .item {
                                height: 35px;
                                line-height: 35px;
                                display: flex;
                                justify-content: space-between;
                                text-align: center;
                                + .item {
                                    border-top: 1px solid #E6C8A2;
                                }
                                &:nth-child(1),&:nth-child(2),&:nth-child(3) {
                                    .ball {
                                        background: #E74F4A;
                                    }
                                }
                                .ball {
                                    display: inline-block;
                                    background: #AF7A38;
                                    border-radius: 100%;
                                    color: #ffffff;
                                    width: 25px;
                                    height: 25px;
                                    line-height: 25px;
                                }
                                .b0 {
                                    width: 60px;
                                    height: 26px;
                                    line-height: 24px;
                                    text-align: center;
                                    box-sizing: border-box;
                                    border: 1px solid #D29449;
                                    border-radius: 3px;
                                    display: inline-block;
                                    cursor: pointer;
                                    &:hover {
                                        opacity: 0.9;
                                    }
                                }
                                .b1 {
                                    color: #D29449;
                                    border-color: #D29449;
                                    background: #FFEBD8;
                                }
                                .b2 {
                                    color: #EC4B43;
                                    border-color: #EC4B43;
                                    background: #FED7D8;
                                }
                            }
                        }
                    }
                }
            }
            .main-bd_right {
                width: 530px;
                height: 590px;
                background: #FAEADA;
                border: 1px solid #DDA76B;
                box-sizing: border-box;
                position: relative;
                .hd {
                    height: 44px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    box-sizing: border-box;
                    padding: 0 16px 0 10px;
                    background: linear-gradient(#B9791F, #794F1F);
                    .l {
                        width: 150px;
                        .el-select {
                            height: 30px;
                            .el-input__inner {
                                height: 30px;
                                line-height: 30px;
                            }
                            .el-input__icon {
                                line-height: 30px;
                            }
                        }
                    }
                    .r {
                        button {
                            width:70px;
                        }
                    }
                }
                .bd {
                    height: 503px;
                    font-size: 12px;
                    color: #88522a;
                    padding: 0 0 0 12px;
                    display: flex;
                    box-sizing: border-box;
                    div {
                        flex: 1;
                        .item {
                            margin-top: 10px;
                            word-wrap:break-word;
                            line-height: 1.5;
                            .line {
                                padding: 5px;
                                display: block;
                                clear: both;
                            }
                        }
                        .item:last-child {
                            margin-bottom: 10px;
                        }
                    }
                }
                .ft {
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    box-sizing: border-box;
                    background: #9A681F;
                    color: #ffffff;
                    span {
                        font-weight: bold;
                        color: #fff14f;
                        padding: 0 2px;
                    }
                }
            }
        }
    }

    .adv_right {
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        top: 0;
        .adv_img {
            width: 100%;
            height: auto;
            z-index: 9;
            cursor: pointer;
        }
        .adv_close {
            position: absolute;
            right: 0;
            top: 0;
            z-index: 10;
            width: auto;
            height: auto;
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue